import React from 'react';
import PropTypes from 'prop-types';

function CurrentDaySummary({ data = {}, actions, tableData = [], userLevel }) {
    const dataLen = Object.keys(data);

    const retrySettlementHandler = () => {
        const settlementIds = tableData
            .filter(data => data.settlementStatus === 'SETTLED')
            .map(data => data.settlementId);
        actions.retrySettlementRequest({ settlementIds });
    };

    return (
        <>
            {dataLen.length > 0 ? (
                <div className="settlement-summary">
                    <div className="summary-heading">
                        <h3>Summary for current day settlements</h3>
                        {userLevel === 'ADMIN' && (
                            <div
                                className="retry-settlement"
                                onClick={retrySettlementHandler}
                            >
                                Retry Settlement
                            </div>
                        )}
                    </div>
                    <div className="details">
                        <div className="summary-details">
                            <h3 className="heading">Gross Amount</h3>
                            <p className="amount">{data.grossAmt}</p>
                        </div>
                        <div className="summary-details">
                            <h3 className="heading">Refund Amount</h3>
                            <p className="amount">{data.refundAmt}</p>
                        </div>
                        <div className="summary-details">
                            <h3 className="heading">Fee & Charges</h3>
                            <p className="amount">{data.fee}</p>
                        </div>
                        <div className="summary-details">
                            <h3 className="heading">GST</h3>
                            <p className="amount">{data.gst}</p>
                        </div>
                        <div className="summary-details">
                            <h3 className="heading">Net Settlement</h3>
                            <p className="amount">{data.netSettlementAmount}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div />
            )}
        </>
    );
}

CurrentDaySummary.propTypes = {
    data: PropTypes.object,
    tableData: PropTypes.object,
    actions: PropTypes.func,
    userLevel: PropTypes.string,
};

export default CurrentDaySummary;
